var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBio21Lochgrafik16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 269.3 494.2",
    style: {
      enableBackground: "new 0 0 269.3 494.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#83B3E2;}\n\t.st1{fill:#D0DE8E;}\n\t.st2{fill:#D03632;}\n\t.st3{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st4{fill:#F9DB00;}\n\t.st5{fill:#1F54B0;}\n\t.st6{fill:#D1D1D1;}\n\t.st7{fill:#4C702B;}\n\t.st8{fill:#93B838;}\n\t.st9{fill:#B1CC40;}\n\t.st10{fill:#CAF741;}\n\t.st11{fill:#FEF7CE;}\n\t.st12{fill:#DAEDCF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wasser"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.4,89.9c-1.5-4.6-2.6-9.4-3.1-14.3c-0.1-2-0.9-8.5,4.4-17.1c3.9-6.3,6.3-8.5,7.7-8.6 c2.4-0.1,6.3,2.5,10.4,6.2c3.5,3.2,0.7,5.4-2.6,10c-4.8,6.6-2.8,14.2-1.1,18.8c3.2,8.7,13.9,11.9,22,9c14.9-5.2,12.2,0.2,24.9,4.5 c7.6,2.6,15.7,4.9,15.5,10.1c-0.2,6.7-5.2,6.4-9,8.2c-5.4,2.6-2,5.8,0.8,7.9c5.4,3.9,4.9,12.3,0.4,18.7c-3.9,5.5-3.3,7.4,4.3,12.5 c11,7.5-10.5,20.9-13.8,33.9c-2.2,8.8,4.5,13.8-4.7,24.1c-5.2,5.2-9.4,6.7-15.9,8.8c-5.3,1.7-10.9,2-16.3,0.9 c-10.1-2.4-9.1-5.1-6.2-9.4c2.4-3.6,0.8-5.1,0.7-10.1c-0.2-10.7,8.4-13.8,9-27.3c0.6-14.1-10.6-18.3-10.9-35.5 c-0.2-15.3,3.1-21-4.2-31.5C139.8,105.7,133.2,99,130.4,89.9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Abschlag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.6,434.8c-6.2,1.4-4.5,10.4-3.3,15s2.8,10.9,8,10.5s5-8.1,4.1-13.9S145.9,433.4,139.6,434.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.9,404c-5.6,0.9-5.6,7.7-4.8,10.1s2.7,6.8,7.3,6.5c4.9-0.4,4.8-7.1,4.4-9.4S131.4,403.1,125.9,404"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.7,386.1c4.4-2.6,9-2.3,9.6,7.1c0.5,7.6-1.7,9.5-4.8,10.2c-3.7,0.8-6-2.9-7.6-6.5S108.2,388.7,112.7,386.1 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119,394.7c0,2-1.7,3.7-3.7,3.7c-2,0-3.7-1.7-3.7-3.7c0-2,1.7-3.7,3.7-3.7c0,0,0,0,0,0 C117.3,391,119,392.7,119,394.7L119,394.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.9,453.9c0,2-1.7,3.7-3.7,3.7c-2,0-3.7-1.7-3.7-3.7c0-2,1.7-3.7,3.7-3.7l0,0 C145.3,450.2,146.9,451.8,146.9,453.9C146.9,453.9,146.9,453.9,146.9,453.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M144.7,440.6c0,2-1.7,3.7-3.7,3.7c-2,0-3.7-1.7-3.7-3.7c0-2,1.7-3.7,3.7-3.7l0,0 C143,436.9,144.7,438.5,144.7,440.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M130.6,412c0,2-1.7,3.7-3.7,3.7c-2,0-3.7-1.7-3.7-3.7c0-2,1.7-3.7,3.7-3.7c0,0,0,0,0,0 C128.9,408.3,130.6,410,130.6,412"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Weg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M108.6,29.9c0.2,0,14.6-2.2,21.6-2c2.5,0.1,4.8,0.3,7.1,0.5c1.3,0.1,2.5,0.2,3.7,0.3c1.1,0.7,5,3.3,5,6.8 c0,2.7-3.5,5.3-9.8,10l-0.6,0.4C132,48.8,127,56.7,125,61c-3,6.4-3.4,13.8-1.4,22.6c1.9,8.3,3.6,13.1,5.7,16.4l2.5-1.6 c-1.9-3.1-3.5-7.6-5.3-15.5c-1.9-8.2-1.5-14.9,1.1-20.7c1.9-4.1,6.6-11.4,9.8-13.8l0.6-0.4c7.1-5.3,11-8.3,11-12.4 c-0.1-2.5-1.2-4.9-3-6.7c1.6,0,3.1-0.2,4.7-0.4c9.9-1.7,25.5-11.9,26.2-12.4l-1.6-2.5c-0.2,0.1-15.8,10.3-25.1,11.9 c-4.2,0.7-8.3,0.3-12.6-0.1c-2.4-0.2-4.8-0.5-7.4-0.5c-7.3-0.2-21.6,2-22.2,2.1c0,0-0.6,0.9,0.2,1.5S108.6,29.9,108.6,29.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "rough"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M134.6,99.1c2.1,3.1,3.9,5.4,6,7.8c10.1,12.4,6.1,18.9,6.3,34.3c0.2,17.2,11.4,21.5,10.9,35.5 c-0.6,13.5-9.2,16.6-9,27.3c0.1,5,1.8,6.6-0.7,10.1c-3.9,5.2-2,6.9,2.4,9.7c13.3,8.8-4.3,27.8,1.7,49c3.2,11.2-4.7,26.1-21,31 c-17.3,4.6-38.9-1.5-39.8-35.2S70.4,222.4,73.2,191c2.2-24.1,7.1-33.6,24.1-55.9c15.9-20.8,17.2-21.9,24.4-34.6 C126.5,92.1,133.6,97.7,134.6,99.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M144.2,76c-0.1-9.3,4.1-9.4,9.6-19.7c7.5-13.9,17.1-21.2,31-8.2c12.5,11.6,37.3,21.1,26.9,41.2 c-6.7,13-9.8,12.2-18.9,9.2c-12.6-4.2-10.5-9.5-24.4-4.7c-4.6,1.7-9.7,1.6-14.3-0.4C149.5,91.3,144.2,86.7,144.2,76"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "green_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M134.7,106.5c-9-7-13.1,13.2-18.6,24.4c-3.9,8-23.5,29.6-23.7,65.4c-0.2,28.6,5.4,35.4,11.1,60.6 c4.9,21.3,9.5,29.6,22.7,31.4c15.8,2.2,12.4-21,13.5-40.5c0.5-9.9,1.3-29.2,4.8-33.6c2.4-3,2.4-3.8,1.9-9.3 c-0.7-12.6,7.9-14.4,9-29c0.7-10.2-11.8-18.2-11.1-36.5C145,123.5,145.2,114.6,134.7,106.5"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "green_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.1,58.7c4.4-2.2,12.5-5.8,18.6-1.2c6.8,5.1,6.6,12.8,10.5,16.1c8.4,7,5.9,11.6,1.1,17.2 c-2.8,3.2-8.1,6.5-14.1,2.6c-4.9-3.2-9.9-1.3-13.2-0.2c-4.4,1.4-9.3,3.4-17.5-0.9c-3.4-1.8-6.1-5.9-6.1-13.3 c0-4.3,2.9-9.1,6.2-12.7C156.9,61.5,162.9,60.8,167.1,58.7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Put_area"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M168.3,60.8c4.7-2.3,9.6-5,14.7-1.9c3.8,2.3,5.7,5.6,7.9,11.6c2.4,6.5,12.5,8.4,5.1,17 c-2.8,3.3-7,3.2-10.9,0.7c-4.1-2.8-9.5-1.8-15.1,0.8c-12.1,5.5-19,2-20.6-4.4c-1.5-6-0.3-11.3,5.4-17 C159.6,62.8,163.4,63.2,168.3,60.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M124.1,190.9c-0.1-3.3-2.6-6-5.8-6.4c-3.5-0.8-7,1.3-7.9,4.8c-0.1,0.2-0.1,0.5-0.1,0.7c-0.9,4.4,0,10.7,0.5,13 c0.8,3.6,2.8,5.1,6,5.3c4.5,0.2,6.2-2.9,6.7-5.8C124.2,198.7,124.4,194.8,124.1,190.9"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Bunker"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M116.5,208.5c-4,0.1-5.7-3.6-5.6-7.6c0.1-3.5,3.1-8.3,7.4-8s5.2,5.1,5,8.8 C123.1,205.9,120.5,208.4,116.5,208.5"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "B\\xE4ume"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "185.9,40.5 217.9,60.2 224.4,72 237,70.2 219.3,46 218.6,34.4 207.3,26.9 195.7,21.5 192,9.4 192,0  181.3,0.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M176.3,22.6c0-1.8-1.4-3.2-3.2-3.2c-1.3,0-2.4,0.8-2.9,1.9c-1.6-0.7-3.5,0.1-4.2,1.7c-0.6,1.5,0,3.3,1.4,4 c-0.1,0.3-0.1,0.5-0.1,0.8c0,1.8,1.4,3.2,3.2,3.2c1.8,0,3.2-1.4,3.2-3.2c0-0.8-0.3-1.6-0.8-2.1c0.1,0,0.1,0,0.2,0 C174.9,25.8,176.3,24.4,176.3,22.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M177.6,3.9h-0.1c0.1-0.2,0.1-0.5,0.1-0.8c0-1.8-1.4-3.2-3.2-3.2c-0.8,0-1.5,0.3-2.1,0.8 c-1.3-1.1-3.3-1-4.4,0.3c-0.3,0.4-0.5,0.8-0.7,1.2c-0.2,0-0.5-0.1-0.7-0.1c-1.8,0-3.2,1.4-3.2,3.2c0,0,0,0,0,0c0,0.2,0,0.5,0.1,0.7 c-0.5,0.2-0.9,0.4-1.2,0.8c-1.4-1-3.4-0.7-4.4,0.7c-0.1,0.1-0.2,0.3-0.2,0.4c-1.1-1.4-3.1-1.5-4.5-0.4c-0.7,0.6-1.2,1.5-1.2,2.4 c0,0.1,0,0.3,0,0.4c-1.6-0.6-3.5,0.2-4.1,1.8c-0.1,0.2-0.1,0.3-0.2,0.5c-0.4-1.4-1.6-2.3-3.1-2.3c-0.2,0-0.3,0-0.5,0 c1.3-1.2,1.4-3.3,0.2-4.6c-0.2-0.3-0.5-0.5-0.8-0.6c1.4-1.2,1.6-3.2,0.4-4.6c-0.1-0.1-0.1-0.1-0.2-0.2l-5.4-2.6L114.2-2l0.1,21.3 c-1.8,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2c1,0,2-0.5,2.6-1.3c1,1.4,3,1.7,4.4,0.6c0.8-0.6,1.2-1.5,1.3-2.4l18.8,0.1 c0.1,1.7,1.7,3,3.4,2.9c1.7-0.1,3-1.7,2.9-3.4c-0.1-1.5-1.4-2.8-2.9-2.9c-0.1-0.3-0.2-0.5-0.4-0.8c0.4-0.5,0.7-1.1,0.8-1.7 c1.3-0.2,2.4-1.2,2.7-2.5c0.4,1.7,2.2,2.7,3.9,2.3c1.4-0.4,2.4-1.6,2.4-3.1c0-0.1,0-0.3,0-0.4c0.4,0.1,0.8,0.2,1.2,0.2 c1.2,0,2.3-0.7,2.8-1.7c1.1,1.3,3.1,1.5,4.4,0.4c0.1-0.1,0.2-0.2,0.3-0.2c0.4,0.3,0.9,0.5,1.4,0.5c-0.4,0.6-0.7,1.2-0.7,1.9 c0,1.8,1.4,3.2,3.1,3.3c1.8,0,3.2-1.4,3.3-3.1c0-1.6-1.2-3-2.8-3.2c0.6-0.7,0.8-1.7,0.6-2.7c1-0.3,1.7-1.1,2-2.1 c0.2,0.1,0.5,0.1,0.7,0.1c0.7,0,1.4-0.3,2-0.8c0.6,0.5,1.3,0.8,2.1,0.8h0.1c-0.1,0.2-0.1,0.5-0.1,0.8c0,1.8,1.4,3.2,3.2,3.2 c1.8,0,3.2-1.4,3.2-3.2S179.3,3.9,177.6,3.9L177.6,3.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "98.7,99.5 100.5,122.2 76.8,152.6 70,174.2 54.5,155.4 66.1,151.1 61.4,141.6 71.9,138.8 68.7,127.8  79,127.6 76.4,115.4 85.6,119.2 90.1,106.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "62.7,190.6 52.8,194.2 58.4,202.6 55.8,211.6 58.6,224.3 68,223.7 62.9,201.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M196.1,191.2c0-1.8-1.4-3.2-3.1-3.2c-1.8,0-3.2,1.4-3.2,3.1c0,0.6,0.1,1.1,0.4,1.6c-1.5,0.9-2,2.8-1.1,4.4 c0.9,1.5,2.8,2,4.4,1.1c1.5-0.9,2-2.8,1.1-4.3C195.5,193.3,196.1,192.3,196.1,191.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M194.4,224.1c0-1.8-1.4-3.2-3.2-3.2c-1.8,0-3.2,1.4-3.2,3.2c0,0.6,0.1,1.1,0.4,1.6c-1.5,0.9-2,2.9-1.1,4.4 s2.9,2,4.4,1.1c1-0.6,1.6-1.6,1.6-2.7c0-0.6-0.2-1.1-0.4-1.6C193.8,226.3,194.4,225.2,194.4,224.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M193.5,211.8c-1.1,0-2.1,0.6-2.7,1.5c-0.9-1.5-2.9-2-4.4-1.1c-0.7,0.4-1.3,1.2-1.5,2 c-1.5-0.9-3.4-0.4-4.3,1.1c-0.1,0.2-0.2,0.4-0.3,0.6l-0.1-0.1c-1.5-1-3.4-0.6-4.4,0.9c-0.3,0.5-0.5,1-0.5,1.6 c-1.1-0.1-2.2,0.5-2.8,1.4c-1,1.5-0.6,3.4,0.9,4.4c1,0.6,2.2,0.7,3.2,0.2c0.6,1.7,2.3,2.6,4,2s2.6-2.3,2-4 c-0.3-0.8-0.9-1.5-1.6-1.9c0,0,0.1-0.1,0.1-0.1c0.1-0.2,0.2-0.4,0.3-0.7c0.5,0.4,1.2,0.7,1.9,0.7c1.5,0,2.8-1,3.1-2.5 c1.5,0.9,3.4,0.4,4.3-1.1c0.9,1.5,2.9,2,4.4,1.1s2-2.9,1.1-4.4C195.6,212.3,194.6,211.8,193.5,211.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M195.4,266.2c0,1.8-1.4,3.2-3.2,3.2s-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2c0,0,0,0,0,0 C193.9,263,195.4,264.4,195.4,266.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M196.6,203.8c0,1.8-1.4,3.2-3.2,3.2s-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2h0C195.2,200.7,196.6,202.1,196.6,203.8 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M119.2,431.8c0.5-0.6,0.8-1.3,0.8-2c1.7-0.4,2.8-2.1,2.4-3.8c-0.3-1.5-1.6-2.5-3.1-2.5c-0.3,0-0.7,0.1-1,0.2 c-0.1-1-0.7-1.9-1.6-2.4c1-1.5,0.5-3.4-0.9-4.4c-0.5-0.3-1.1-0.5-1.7-0.5c-0.5,0-0.9,0.1-1.3,0.3c-0.1-0.6-0.3-1.1-0.7-1.5 c1-1.5,0.6-3.4-0.9-4.4c-0.5-0.3-1-0.5-1.6-0.5c0-0.1,0-0.1,0-0.2c0-1.8-1.4-3.2-3.2-3.2s-3.2,1.4-3.2,3.2c0,0.9,0.3,1.7,1,2.3 c-1.7,0.2-3,1.8-2.8,3.5c0.2,1.7,1.8,3,3.5,2.8c0.6-0.1,1.2-0.3,1.6-0.7c0.4,1.7,2.1,2.7,3.8,2.3c0.2-0.1,0.4-0.1,0.6-0.2 c0.1,1,0.7,1.8,1.6,2.3c-0.3,0.5-0.5,1.1-0.5,1.7c0,1.6,1.2,3,2.9,3.1c-0.8,0.6-1.2,1.5-1.2,2.5c0,1.7,1.3,3.1,3,3.2 c-0.5,0.6-0.8,1.3-0.8,2.1c0,1.8,1.4,3.2,3.2,3.2c1.8,0,3.2-1.4,3.2-3.2C122.1,433.2,120.8,431.8,119.2,431.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M106.2,395.4c1.3-1.2,1.4-3.2,0.2-4.4c-0.4-0.4-0.9-0.7-1.4-0.9c1.3-1.1,1.5-3.1,0.3-4.5 c-1.1-1.3-3.1-1.5-4.5-0.3c-0.6,0.5-1,1.3-1.1,2l0,0c-1.8,0-3.2,1.4-3.2,3.2c0,0.1,0,0.3,0,0.4c-0.2,0-0.4-0.1-0.6-0.1 c-1.8,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2c0,0,0,0,0,0c0.4,0,0.9-0.1,1.3-0.3c0.3,1,1,1.8,2,2.1c-1.4,1-1.8,3-0.8,4.4 c1,1.4,3,1.8,4.4,0.8c0.8-0.6,1.4-1.6,1.4-2.6c0-0.3,0-0.5-0.1-0.8c1.8,0,3.1-1.5,3.1-3.2C107.2,396.8,106.9,396,106.2,395.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M108.9,74.5l6.8-23.3l5.4-8.7c0.3,0,2.4,3,4.1,3c1.7,0,3.1-1.3,3.2-3c0.3,0.1,0.5,0.1,0.8,0.1 c1.4,0,2.6-0.9,3-2.3c0.2,0,0.3,0,0.5,0c0.8,0,1.6-0.3,2.2-0.9c1,1.5,2.9,1.9,4.4,0.9c1.5-1,1.9-2.9,0.9-4.4 c-1-1.5-2.9-1.9-4.4-0.9c-0.2,0.1-0.3,0.3-0.5,0.4c-0.6-0.9-1.6-1.4-2.6-1.4c-0.1,0-0.3,0-0.4,0c1.6-0.6,2.4-2.5,1.8-4.1 c-0.6-1.6-2.5-2.4-4.1-1.8c-0.2,0.1-0.3,0.1-0.5,0.2c-1.4-0.8-3.2-0.4-4.1,1c-1.1-1.4-3.1-1.6-4.4-0.5c-0.5,0.4-0.9,1-1.1,1.6 c-0.9-1.5-2.9-2-4.4-1.1c-1.5,0.9-2,2.9-1.1,4.4c0,0,0.1,0.1,0.1,0.1c0,0.1,0.1,0.2,0.2,0.3c-0.9,0.6-1.4,1.6-1.4,2.6l-4.7,7 c-0.8,0-1.6,0.3-2.2,0.8c-0.6-0.5-1.4-0.8-2.2-0.8c-1.8,0-3.3,1.5-3.3,3.3s1.5,3.3,3.3,3.3h0.2l-0.1,1.8c-0.6-0.4-1.3-0.7-2-0.7 c-1.8,0-3.3,1.4-3.4,3.3c0,0.8,0.3,1.6,0.9,2.2c-1.7,0.6-2.6,2.4-2,4.1c0.4,1.2,1.5,2.1,2.8,2.2c0,0.6,0.3,1.2,0.6,1.7 c-1.7,0.5-2.7,2.3-2.2,4c0.3,0.9,0.9,1.6,1.7,2c0,0.6,0.2,1.2,0.6,1.7c-1.6,0.8-2.2,2.7-1.4,4.3c0.1,0.3,0.3,0.5,0.5,0.7h-0.1 c-1.8,0-3.4,1.4-3.4,3.2c0,0,0,0.1,0,0.1c0,0.6,0.2,1.3,0.6,1.8c-1.6,0.6-2.4,2.5-1.8,4.1c0.5,1.2,1.6,2,2.8,2 c0.6,1,1.6,1.6,2.7,1.7c-0.1,0.1-0.2,0.2-0.2,0.2c-0.8,1-0.9,2.3-0.3,3.4c-1.2-0.3-2.5,0.2-3.2,1.2c-1.1,1.5-0.8,3.5,0.7,4.6 c0,0,0,0,0,0c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.1-0.2,0.2-0.3,0.4c-1.1,1.5-0.8,3.6,0.8,4.7c1.1,0.8,2.6,0.9,3.7,0.1l-0.2,3.5 c0.4,1.4,1.7,2.4,3.2,2.4c0.6,0,1.2-0.2,1.8-0.5c0,0.5,0.2,0.9,0.4,1.3c-1.6,0.2-2.8,1.5-2.8,3.1c0,0.2,0,0.4,0.1,0.6h-0.2 c-1.8,0-3.2,1.4-3.2,3.2c0,1.8,1.4,3.2,3.2,3.2c1.8,0,3.2-1.4,3.2-3.2c0,0,0,0,0,0c0-0.2,0-0.4-0.1-0.6h0.2c1.7,0,3.2-1.4,3.2-3.1 c0-0.6-0.1-1.1-0.4-1.6c1.7-0.2,3-1.7,2.8-3.4c0-0.2-0.1-0.4-0.1-0.6c1-0.5,1.7-1.5,1.8-2.7c1.8-0.1,3.1-1.6,3-3.4 c-0.1-1.4-1.1-2.6-2.4-2.9c-0.1-0.8-0.5-1.5-1.1-2c1-1.5,0.7-3.5-0.8-4.6c-0.6-0.4-1.2-0.6-1.9-0.6c-0.2,0-0.3,0-0.5,0l-0.4-0.7 c1.7-0.1,3.1-1.5,3.1-3.2c0-1.1-0.5-2-1.4-2.6c0.4-0.8,0.4-1.8,0-2.6c0.2-0.3,0.3-0.6,0.3-0.8c0.2-0.9,0-1.8-0.6-2.6L108.9,74.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M165.6,2.6c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C162.9-3.5,165.6-0.8,165.6,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M154.1,7.1c0,3.4-2.7,6.2-6.1,6.2c-3.4,0-6.2-2.7-6.2-6.1c0-3.4,2.7-6.2,6.1-6.2c0,0,0,0,0,0 C151.3,1,154.1,3.8,154.1,7.1C154.1,7.2,154.1,7.2,154.1,7.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M144.2,488c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C141.4,481.8,144.2,484.6,144.2,488"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M132,468.4c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2h0 C129.2,462.2,132,465,132,468.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M133,460.9c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C130.2,454.7,133,457.5,133,460.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M125.6,443.2c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C122.8,437,125.6,439.7,125.6,443.2C125.6,443.2,125.6,443.2,125.6,443.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M152.6,478.7c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C149.8,472.5,152.6,475.3,152.6,478.7C152.6,478.7,152.6,478.7,152.6,478.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M146.6,475.7c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C143.8,469.5,146.6,472.3,146.6,475.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M162,469.9c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C159.2,463.7,162,466.5,162,469.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M167.6,474c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C164.8,467.8,167.6,470.6,167.6,474C167.6,474,167.6,474,167.6,474"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M167.3,442.6c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C164.5,436.4,167.3,439.2,167.3,442.6C167.3,442.6,167.3,442.6,167.3,442.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M172.9,447.1c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2h0 C170.2,440.9,172.9,443.7,172.9,447.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M173.1,457.8c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2S173.1,454.3,173.1,457.8 L173.1,457.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M173,434.9c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2C170.2,428.7,173,431.5,173,434.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M171.5,422.7c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C168.7,416.6,171.5,419.3,171.5,422.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M166.2,394.1c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C163.5,388,166.2,390.7,166.2,394.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M173.5,383.3c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C170.8,377.1,173.5,379.9,173.5,383.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M169.6,374.5c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C166.8,368.3,169.6,371.1,169.6,374.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M179.2,367c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2h0 C176.4,360.8,179.2,363.6,179.2,367"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M169.6,359.5c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C166.8,353.3,169.6,356.1,169.6,359.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M174.5,349.6c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C171.7,343.4,174.5,346.2,174.5,349.6L174.5,349.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M177.7,338.8c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C174.9,332.6,177.7,335.3,177.7,338.8L177.7,338.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M174.8,326.6c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2h0 C172,320.4,174.8,323.2,174.8,326.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M167.6,331.5c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2h0 C164.8,325.3,167.6,328,167.6,331.5C167.6,331.4,167.6,331.5,167.6,331.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M102.8,368.8c-0.7,3.3-3.9,5.5-7.3,4.8s-5.5-3.9-4.8-7.3c0.7-3.3,3.9-5.5,7.3-4.8c0,0,0,0,0,0 C101.4,362.2,103.5,365.5,102.8,368.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M97.5,352.1c-0.7,3.3-4,5.5-7.3,4.8c-3.3-0.7-5.5-4-4.8-7.3c0.7-3.3,4-5.5,7.3-4.8c0,0,0,0,0,0 C96.1,345.5,98.2,348.8,97.5,352.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M95.2,334.5c-0.7,3.3-4,5.5-7.3,4.8c-3.3-0.7-5.5-4-4.8-7.3c0.7-3.3,4-5.5,7.3-4.8c0,0,0,0,0,0 C93.7,328,95.9,331.2,95.2,334.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M92.5,318.1c-0.7,3.3-4,5.5-7.3,4.8c-3.3-0.7-5.5-4-4.8-7.3c0.7-3.3,4-5.5,7.3-4.8c0,0,0,0,0,0 C91,311.5,93.2,314.8,92.5,318.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M77.1,307.4c-0.7,3.3-4,5.5-7.3,4.8s-5.5-4-4.8-7.3c0.7-3.3,4-5.5,7.3-4.8c0,0,0,0,0,0 C75.6,300.7,77.8,304,77.1,307.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M88.2,273.5c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C85.4,267.3,88.2,270.1,88.2,273.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M79.2,272.4c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C76.4,266.2,79.2,269,79.2,272.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M74.7,261.9c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C71.9,255.7,74.7,258.5,74.7,261.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M86.7,280.6c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C83.9,274.4,86.7,277.2,86.7,280.6L86.7,280.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M86.2,263.5c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C83.4,257.4,86.2,260.1,86.2,263.5L86.2,263.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M72.1,254c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2h0 C69.3,247.8,72.1,250.6,72.1,254C72.1,254,72.1,254,72.1,254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M81.9,252c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C79.1,245.8,81.9,248.6,81.9,252"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M67,232.9c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C64.2,226.7,67,229.5,67,232.9C67,232.9,67,232.9,67,232.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M76.6,235.5c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C73.9,229.3,76.6,232.1,76.6,235.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M79.3,243.5c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C76.5,237.4,79.3,240.1,79.3,243.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M67.7,244.5c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C64.9,238.3,67.7,241.1,67.7,244.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M66.1,223.9c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C63.3,217.7,66.1,220.5,66.1,223.9C66.1,223.9,66.1,223.9,66.1,223.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M74,223.1c0,3.4-2.7,6.2-6.1,6.2c-3.4,0-6.2-2.7-6.2-6.1c0-3.4,2.7-6.2,6.1-6.2c0,0,0,0,0.1,0 C71.2,217,74,219.8,74,223.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M73.1,214c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C70.3,207.8,73.1,210.6,73.1,214C73.1,214,73.1,214,73.1,214"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M67.4,202.2c0,3.4-2.8,6.2-6.2,6.1s-6.2-2.8-6.1-6.2c0-3.4,2.8-6.1,6.2-6.1C64.6,196,67.4,198.8,67.4,202.2 C67.4,202.2,67.4,202.2,67.4,202.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M69.2,190c0,3.4-2.7,6.2-6.1,6.2c-3.4,0-6.2-2.7-6.2-6.1c0-3.4,2.7-6.2,6.1-6.2c0,0,0,0,0,0 C66.4,183.9,69.2,186.6,69.2,190"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M57.4,194.7c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2h0 C54.7,188.5,57.4,191.3,57.4,194.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M60.9,212.6c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2h0 C58.1,206.4,60.9,209.2,60.9,212.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M66.8,180.3c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2h0C64,174.1,66.8,176.9,66.8,180.3 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M208.3,147.4c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C205.5,141.2,208.3,143.9,208.3,147.4C208.3,147.3,208.3,147.3,208.3,147.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M217.3,119.3c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2l0,0 C214.5,113.2,217.3,115.9,217.3,119.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M205.5,178c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C202.8,171.8,205.5,174.6,205.5,178C205.5,178,205.5,178,205.5,178"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M107.7,110.9c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C104.9,104.7,107.7,107.5,107.7,110.9C107.7,110.9,107.7,110.9,107.7,110.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M105.3,121.8c0.3,3.4-2.2,6.4-5.6,6.7s-6.4-2.2-6.7-5.6c-0.3-3.4,2.2-6.4,5.6-6.7 C101.9,115.9,104.9,118.4,105.3,121.8C105.3,121.8,105.3,121.8,105.3,121.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M98.5,131.6c0.3,3.4-2.2,6.4-5.6,6.7c-3.4,0.3-6.4-2.2-6.7-5.6c-0.3-3.4,2.2-6.4,5.5-6.7 C95.1,125.8,98.1,128.2,98.5,131.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M90.8,140.8c0.3,3.4-2.2,6.4-5.6,6.7c-3.4,0.3-6.4-2.2-6.7-5.6c-0.3-3.4,2.1-6.4,5.5-6.7 C87.4,134.9,90.4,137.4,90.8,140.8C90.7,140.8,90.7,140.8,90.8,140.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M83.8,151.1c0.3,3.4-2.2,6.4-5.5,6.8s-6.4-2.2-6.8-5.5s2.2-6.4,5.5-6.8c0,0,0,0,0,0 C80.5,145.3,83.5,147.7,83.8,151.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M79,162.9c0.3,3.4-2.2,6.4-5.6,6.7c-3.4,0.3-6.4-2.2-6.7-5.6c-0.3-3.4,2.2-6.4,5.5-6.7 C75.7,157,78.7,159.5,79,162.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M75.6,174.8c0.3,3.4-2.2,6.4-5.6,6.7s-6.4-2.2-6.7-5.6c-0.3-3.4,2.2-6.4,5.6-6.7 C72.2,169,75.3,171.4,75.6,174.8C75.6,174.8,75.6,174.8,75.6,174.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M96.2,107c0.3,3.4-2.2,6.4-5.6,6.7s-6.4-2.2-6.7-5.6c-0.3-3.4,2.2-6.4,5.5-6.7 C92.8,101.1,95.9,103.6,96.2,107"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M104.2,98.7c0.3,3.4-2.2,6.4-5.6,6.7c-3.4,0.3-6.4-2.2-6.7-5.6c-0.3-3.4,2.2-6.4,5.5-6.7 C100.9,92.9,103.9,95.4,104.2,98.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M94.7,119.5c0.4,3.4-2.1,6.4-5.5,6.8s-6.4-2.1-6.8-5.5c-0.4-3.4,2.1-6.4,5.5-6.8c0,0,0.1,0,0.1,0 C91.4,113.7,94.4,116.2,94.7,119.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M86.2,128.7c0.3,3.4-2.2,6.4-5.6,6.7s-6.4-2.2-6.7-5.6c-0.3-3.4,2.2-6.4,5.6-6.7 C82.9,122.8,85.9,125.3,86.2,128.7C86.2,128.7,86.2,128.7,86.2,128.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M82.5,116.3c0.3,3.4-2.2,6.4-5.6,6.7s-6.4-2.2-6.7-5.6c-0.3-3.4,2.2-6.4,5.5-6.7 C79.2,110.4,82.2,112.9,82.5,116.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M78.2,140.1c0.3,3.4-2.2,6.4-5.6,6.7s-6.4-2.2-6.7-5.6c-0.3-3.4,2.2-6.4,5.6-6.7 C74.9,134.2,77.9,136.7,78.2,140.1C78.2,140.1,78.2,140.1,78.2,140.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M73.9,128.5c0.3,3.4-2.2,6.4-5.6,6.7s-6.4-2.2-6.7-5.6c-0.3-3.4,2.2-6.4,5.6-6.7 C70.6,122.6,73.6,125.1,73.9,128.5C73.9,128.5,73.9,128.5,73.9,128.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M71.6,152.4c0.3,3.4-2.2,6.4-5.5,6.7c-3.4,0.3-6.4-2.2-6.7-5.5c-0.3-3.4,2.2-6.4,5.5-6.7c0,0,0,0,0,0 C68.3,146.5,71.3,149,71.6,152.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M65.7,141.4c0.3,3.4-2.2,6.4-5.5,6.7s-6.4-2.2-6.7-5.5c-0.3-3.4,2.2-6.4,5.5-6.7c0,0,0,0,0,0 C62.4,135.5,65.4,138,65.7,141.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M67.5,164.6c0.3,3.4-2.2,6.4-5.6,6.7c-3.4,0.3-6.4-2.2-6.7-5.6c-0.3-3.4,2.2-6.4,5.5-6.7 C64.2,158.7,67.2,161.2,67.5,164.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M63.4,170.3c0.3,3.4-2.2,6.4-5.6,6.7c-3.4,0.3-6.4-2.2-6.7-5.6c-0.3-3.4,2.2-6.4,5.6-6.7 C60,164.4,63.1,166.9,63.4,170.3C63.4,170.3,63.4,170.3,63.4,170.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M59.7,155.2c0.3,3.4-2.2,6.4-5.6,6.7c-3.4,0.3-6.4-2.2-6.7-5.6c-0.3-3.4,2.2-6.4,5.6-6.7 C56.3,149.3,59.3,151.8,59.7,155.2C59.7,155.2,59.7,155.2,59.7,155.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M118.8,56.5c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C116,50.3,118.8,53.1,118.8,56.5C118.8,56.5,118.8,56.5,118.8,56.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M115.1,68.3c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C112.3,62.1,115.1,64.9,115.1,68.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M109.3,64.7c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C106.5,58.5,109.3,61.3,109.3,64.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M103.1,75.1c0,3.4-2.7,6.2-6.1,6.2s-6.2-2.7-6.2-6.1s2.7-6.2,6.1-6.2c0,0,0,0,0,0 C100.3,69,103.1,71.8,103.1,75.1C103.1,75.2,103.1,75.2,103.1,75.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M103.6,87.4c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C100.8,81.2,103.6,83.9,103.6,87.4C103.6,87.4,103.6,87.4,103.6,87.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M114.3,80.6c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C111.5,74.4,114.3,77.2,114.3,80.6C114.3,80.6,114.3,80.6,114.3,80.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M114.2,93.7c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C111.5,87.5,114.2,90.3,114.2,93.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M142.9,13.3c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C140.1,7.1,142.9,9.9,142.9,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M132.4,20c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C129.6,13.9,132.4,16.6,132.4,20C132.4,20,132.4,20,132.4,20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M131.3,33.3c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2C128.5,27.1,131.3,29.8,131.3,33.3 C131.3,33.3,131.3,33.3,131.3,33.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M138.4,35.5c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C135.6,29.3,138.4,32.1,138.4,35.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M120.6,14.6c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2l0,0 C117.8,8.5,120.6,11.2,120.6,14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M130.9,8.1c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2l0,0C128.1,1.9,130.9,4.7,130.9,8.1 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M106.8,52.9c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C104,46.8,106.8,49.5,106.8,52.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M115,47.7c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C112.2,41.5,115,44.3,115,47.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M124.4,45.4c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C121.6,39.2,124.4,42,124.4,45.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M119.4,36.8c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2l0,0 C116.6,30.7,119.4,33.4,119.4,36.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M120,1.7c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2l0,0C117.2-4.5,120-1.7,120,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M229.8,68.5c3.4,0,6.2,2.7,6.2,6.1c0,0,0,0,0,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M236,74.6c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C233.2,68.5,236,71.2,236,74.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M240.8,70.3c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C238.1,64.2,240.8,66.9,240.8,70.3C240.8,70.3,240.8,70.3,240.8,70.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M229,70c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C226.2,63.8,229,66.6,229,70C229,70,229,70,229,70"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M232.8,50.3c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C230,44.2,232.8,46.9,232.8,50.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M235.9,59.7c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C233.1,53.6,235.9,56.3,235.9,59.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M224.7,33.2c0,3.4-2.7,6.2-6.2,6.2c-3.4,0-6.2-2.7-6.2-6.2s2.7-6.2,6.2-6.2c0,0,0,0,0,0 C221.9,27,224.7,29.8,224.7,33.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M224.5,46.1c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2l0,0 C221.7,39.9,224.5,42.6,224.5,46.1C224.5,46.1,224.5,46.1,224.5,46.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M223.8,58.8c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C221,52.6,223.8,55.4,223.8,58.8C223.8,58.8,223.8,58.8,223.8,58.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M213.1,52c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C210.3,45.9,213.1,48.6,213.1,52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M213.6,27.4c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C210.9,21.2,213.6,24,213.6,27.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M213.5,39.9c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C210.7,33.7,213.5,36.5,213.5,39.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M202.2,45.9c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C199.5,39.7,202.2,42.5,202.2,45.9C202.2,45.9,202.2,45.9,202.2,45.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M202.6,33.7c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C199.8,27.6,202.6,30.3,202.6,33.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M202.6,21.4c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C199.8,15.2,202.6,18,202.6,21.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M191.2,39.9c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2C188.4,33.7,191.2,36.5,191.2,39.9 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M191.2,27.4c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2C188.4,21.2,191.2,24,191.2,27.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M197.6,10c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0C194.8,3.8,197.6,6.6,197.6,10 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M166.2,15.1c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C163.5,8.9,166.2,11.7,166.2,15.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M189,14.6c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C186.2,8.4,189,11.1,189,14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M156.2,19.4c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 C153.4,13.2,156.2,16,156.2,19.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M144.3,19.5c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2l0,0 C141.5,13.3,144.3,16,144.3,19.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M177.4,9.6c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C174.7,3.4,177.4,6.2,177.4,9.6C177.5,9.6,177.4,9.6,177.4,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M168.8,29.8c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2l0,0C166,23.6,168.8,26.4,168.8,29.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M187.5,1.7c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0,0,0,0,0,0 C184.7-4.4,187.5-1.7,187.5,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M170.6,267.4c0-3.5,2.8-6.4,6.4-6.4s6.4,2.8,6.4,6.4c0,3.5-2.8,6.4-6.4,6.4h0 C173.4,273.8,170.6,270.9,170.6,267.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M178.3,223c0-3.5,2.8-6.4,6.4-6.4s6.4,2.8,6.4,6.4s-2.8,6.4-6.4,6.4S178.3,226.5,178.3,223L178.3,223"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M179.8,238.1c0-3.5,2.8-6.4,6.4-6.4s6.4,2.8,6.4,6.4s-2.8,6.4-6.4,6.4S179.8,241.6,179.8,238.1L179.8,238.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M190.8,236.2c0-3.5,2.8-6.4,6.4-6.4s6.4,2.8,6.4,6.4s-2.8,6.4-6.4,6.4S190.8,239.7,190.8,236.2L190.8,236.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M184.7,247.7c0-3.5,2.8-6.4,6.4-6.4c3.5,0,6.4,2.8,6.4,6.4c0,3.5-2.8,6.4-6.4,6.4c0,0,0,0,0,0 C187.5,254.1,184.7,251.2,184.7,247.7L184.7,247.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M184.1,258.6c0-3.5,2.9-6.4,6.4-6.3c3.5,0,6.4,2.9,6.4,6.4c0,3.5-2.9,6.4-6.4,6.4 C187,265,184.1,262.2,184.1,258.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M172,281.8c0-3.5,2.8-6.4,6.4-6.4s6.4,2.8,6.4,6.4c0,3.5-2.8,6.4-6.4,6.4h0C174.8,288.2,172,285.3,172,281.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M155.7,318.6c0-3.5,2.8-6.4,6.4-6.4s6.4,2.8,6.4,6.4c0,3.5-2.8,6.4-6.4,6.4h0 C158.6,324.9,155.7,322.1,155.7,318.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M168.8,319.9c0-3.5,2.8-6.4,6.4-6.4s6.4,2.8,6.4,6.4c0,3.5-2.8,6.4-6.4,6.4h0 C171.6,326.2,168.8,323.4,168.8,319.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M172.5,307.7c0-3.5,2.8-6.4,6.4-6.4s6.4,2.8,6.4,6.4c0,3.5-2.8,6.4-6.4,6.4h0 C175.4,314.1,172.5,311.2,172.5,307.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M154.8,301.7c0-3.5,2.8-6.4,6.4-6.4s6.4,2.8,6.4,6.4c0,3.5-2.8,6.4-6.4,6.4h0 C157.7,308,154.8,305.2,154.8,301.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBio21Lochgrafik16);
export default __webpack_public_path__ + "static/media/BIO21_lochgrafik_16.4cc40cf4bc0f55f00f3e32706b766984.svg";
export { ForwardRef as ReactComponent };